export default [
  {
    path: "/document-approval",
    name: "title.documentApproval",
    component: () => import("@/modules/document-approval/view/DocumentApprovalPage.vue"),
  },
];
